import { Suggestion, GroupedSuggestions, PositionSuggestionsParams } from '@borg/types';
import { deduplicateSuggestionsByName, DeduplicatedSuggestion } from '@borg/utils';

class PositionsService {
  search = async (query: string) => {
    const result = await serviceHttpGetFactory<Suggestion[]>(`/positions?search=${query}`);

    if (result.isSuccess) {
      const deduplicated = deduplicateSuggestionsByName(result.data);
      return {
        ...result,
        data: deduplicated as DeduplicatedSuggestion<Suggestion>[]
      };
    }

    return result;
  };

  getSuggestions = (params?: PositionSuggestionsParams) =>
    serviceHttpGetFactory<GroupedSuggestions>('/suggestions/positions', params);
}

export const positionsService = new PositionsService();
